(function () {
  function initSlider(root) {
    if (!root) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-slider-card]'));
    var infos = Array.prototype.slice.call(root.querySelectorAll('[data-slider-info]'));
    var bullets = Array.prototype.slice.call(root.querySelectorAll('[data-slider-bullet]'));
    var bulletsWrap = root.querySelector('.card-slider__bullets');
    var paginationCurrent = root.querySelector('[data-slider-pagination-current]');
    var visibleCardsInput = root.querySelector('[data-slider-visible-cards]');

    if (!cards.length) return;

    var activeIndex = 0;
    var isAnimating = false;
    var visibleCards = cards.length;
    if (visibleCardsInput) {
      var parsedVisible = Number(visibleCardsInput.value);
      if (!Number.isNaN(parsedVisible) && parsedVisible > 0) {
        visibleCards = Math.min(parsedVisible, cards.length);
      }
    }

    function getEffectiveVisibleCards() {
      if (window.matchMedia('(max-width: 989px)').matches) {
        // Mobile: afficher uniquement la carte active + une carte "behind".
        // Sinon, toutes les cartes non-actives passent en `is-behind` (opacity: 1)
        // et on observe un "flash" de la carte précédente lors du swap.
        return Math.min(2, cards.length);
      }
      return visibleCards;
    }

    function applyStack(currentIndex) {
      var total = cards.length;
      var effectiveVisibleCards = getEffectiveVisibleCards();
      var desktopMode = window.matchMedia('(min-width: 990px)').matches;
      var slots = Math.max(effectiveVisibleCards - 1, 1);

      cards.forEach(function (card, i) {
        card.classList.remove('is-active', 'is-entering', 'is-leaving', 'is-behind', 'is-hidden-stack');

        if (i === currentIndex) {
          card.classList.add('is-active');
          card.style.zIndex = String(total + 2);
          card.style.setProperty('--stack-order', '0');
          card.style.setProperty('--card-left', '0%');
          card.style.setProperty('--card-scale', '1');
          card.style.setProperty('--stack-delay', '0ms');
          return;
        }

        // Distance from active card in circular order: 1,2,3...
        var distance = (i - currentIndex + total) % total;
        if (distance < effectiveVisibleCards) {
          card.classList.add('is-behind');
          card.style.zIndex = String(total + 1 - distance);
          card.style.setProperty('--stack-order', String(distance));
          if (desktopMode) {
            var leftPercent = 0;
            var desktopLeftByVisibleCards = {
              2: [20],
              3: [0, 23],
              4: [0, 11.5, 23],
              5: [0, 10.666667, 18.333333, 23],
            };
            var leftSteps = desktopLeftByVisibleCards[effectiveVisibleCards];
            if (leftSteps && leftSteps[distance - 1] !== undefined) {
              leftPercent = leftSteps[distance - 1];
            } else if (effectiveVisibleCards >= 3) {
              leftPercent = 0 + (distance - 1) * (23 / (slots - 1 || 1));
            }

            var firstBehindScale = 572 / 646;
            var secondBehindScale = 517 / 646;
            var afterSecondStep = 0.075;
            var cardScale = firstBehindScale;
            if (effectiveVisibleCards === 2 && distance === 1) {
              cardScale = 0.95;
            } else
            if (distance === 2) {
              cardScale = secondBehindScale;
            } else if (distance > 2) {
              cardScale = secondBehindScale - (distance - 2) * afterSecondStep;
            }
            cardScale = Math.max(cardScale, 0.62);
            card.style.setProperty('--card-left', String(leftPercent) + '%');
            card.style.setProperty('--card-scale', String(cardScale));
            card.style.setProperty('--stack-delay', String((distance - 1) * 75) + 'ms');
          } else {
            card.style.setProperty('--card-left', '0%');
            card.style.setProperty('--card-scale', '0.85');
            card.style.setProperty('--stack-delay', '0ms');
          }
        } else {
          card.classList.add('is-hidden-stack');
          card.style.zIndex = '0';
          card.style.setProperty('--stack-order', String(distance));
          card.style.setProperty('--card-left', '56%');
          card.style.setProperty('--card-scale', '0.82');
          card.style.setProperty('--stack-delay', '0ms');
        }
      });
    }

    function animateBulletsFromRects(previousRectsByIndex) {
      if (!previousRectsByIndex || !bullets.length) return;

      bullets.forEach(function (bullet) {
        var key = bullet.getAttribute('data-bullet-index');
        var prev = previousRectsByIndex[key];
        if (!prev) return;
        var next = bullet.getBoundingClientRect();
        var deltaX = prev.left - next.left;
        bullet.style.transition = 'none';
        bullet.style.transform = 'translateX(' + String(deltaX) + 'px)';
      });

      requestAnimationFrame(function () {
        bullets.forEach(function (bullet) {
          bullet.style.transition = 'transform 0.34s cubic-bezier(.22, .61, .36, 1)';
          bullet.style.transform = 'translateX(0)';
        });

        window.setTimeout(function () {
          bullets.forEach(function (bullet) {
            bullet.style.transition = '';
            bullet.style.transform = '';
          });
        }, 360);
      });
    }

    function swapBullets(previousIndex, nextIndex) {
      if (!bulletsWrap || previousIndex === nextIndex) return null;

      var previousRectsByIndex = {};
      bullets.forEach(function (bullet) {
        previousRectsByIndex[bullet.getAttribute('data-bullet-index')] = bullet.getBoundingClientRect();
      });

      var prevBullet = bulletsWrap.querySelector('[data-bullet-index="' + String(previousIndex) + '"]');
      var nextBullet = bulletsWrap.querySelector('[data-bullet-index="' + String(nextIndex) + '"]');
      if (!prevBullet || !nextBullet || prevBullet === nextBullet) return null;

      // Swap DOM nodes in a robust way:
      // - Use element siblings only, so we don't get tricked by whitespace text nodes.
      // - For non-adjacent nodes: move nextBullet before prevBullet, then move prevBullet
      //   before the original "nextBullet next element".
      var parent = bulletsWrap;
      var isNextImmediatelyAfterPrev = nextBullet.previousElementSibling === prevBullet;
      var isPrevImmediatelyAfterNext = prevBullet.previousElementSibling === nextBullet;

      if (isNextImmediatelyAfterPrev) {
        parent.insertBefore(nextBullet, prevBullet);
      } else if (isPrevImmediatelyAfterNext) {
        parent.insertBefore(prevBullet, nextBullet);
      } else {
        var nextBulletNextEl = nextBullet.nextElementSibling; // element after nextBullet (original)
        parent.insertBefore(nextBullet, prevBullet);
        // If nextBulletNextEl is null, insertBefore(prevBullet, null) == append.
        parent.insertBefore(prevBullet, nextBulletNextEl);
      }

      bullets = Array.prototype.slice.call(root.querySelectorAll('[data-slider-bullet]'));
      return previousRectsByIndex;
    }

    function syncState(nextIndex, previousIndex) {
      // Important: on évite de réordonner le DOM des bullets.
      // Sinon, la bullet "active" peut visuellement rester en 1ère position
      // alors que l'état (slide index) change.
      // Le style est déjà animé via CSS (transition sur width/height).
      var previousRectsByIndex = null;

      infos.forEach(function (info, i) {
        info.classList.toggle('is-active', i === nextIndex);
      });

      bullets.forEach(function (bullet) {
        // Important: bullets array order might change due to swapBullets().
        // Always use the stable slide index from data-bullet-index.
        var bulletIndex = Number(bullet.getAttribute('data-bullet-index'));
        var isActive = bulletIndex === nextIndex;
        bullet.classList.toggle('is-active', isActive);
        bullet.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Pas d'animation de swap DOM (voir commentaire ci-dessus).

      if (paginationCurrent) {
        paginationCurrent.textContent = String(nextIndex + 1);
      }
    }

    function prepareBackCardArrival(nextIndex) {
      var backDistance = getEffectiveVisibleCards() - 1;
      if (backDistance < 1) return null;

      var incomingBack = cards[(nextIndex + backDistance) % cards.length];
      if (!incomingBack) return null;

      incomingBack.style.transition = 'none';
      incomingBack.classList.remove('is-hidden-stack', 'is-active', 'is-leaving', 'is-entering', 'is-shrinking');
      incomingBack.classList.add('is-behind');
      incomingBack.style.opacity = '0';
      incomingBack.style.zIndex = '1';
      incomingBack.style.transform = 'translateX(-48%) scale(0.78)';
      void incomingBack.offsetWidth;
      incomingBack.style.transition = '';
      incomingBack.style.opacity = '';
      incomingBack.style.transform = '';
      return incomingBack;
    }

    function playCardSwap(previousIndex, nextIndex, activeCard, nextCard, arriveFromLeft) {
      cards.forEach(function (card) {
        card.classList.remove('is-stack-arrive');
      });
      activeCard.classList.remove('is-shrinking', 'is-behind');
      activeCard.classList.add('is-leaving');
      activeCard.style.setProperty('--card-scale', '0.94');
      activeCard.style.setProperty('--stack-delay', '0ms');

      nextCard.classList.remove('is-behind');
      nextCard.classList.add('is-entering');
      nextCard.style.setProperty('--stack-delay', '0ms');
      nextCard.style.zIndex = String(cards.length + 3);

      // Force reflow before transitioning to active state.
      void nextCard.offsetWidth;
      nextCard.classList.add('is-active');
      nextCard.classList.remove('is-entering');

      syncState(nextIndex, previousIndex);

      // Start the rest of the stack movement immediately (same timeline as next -> active).
      requestAnimationFrame(function () {
        var incomingBack = arriveFromLeft ? prepareBackCardArrival(nextIndex) : null;
        applyStack(nextIndex);
        if (incomingBack) incomingBack.classList.add('is-stack-arrive');

        // Keep foreground transition classes during the shared movement.
        activeCard.classList.remove('is-active', 'is-shrinking');
        activeCard.classList.add('is-leaving');
        activeCard.style.setProperty('--card-scale', '0.94');
        activeCard.style.zIndex = String(cards.length + 1);

        nextCard.classList.remove('is-behind');
        nextCard.classList.add('is-active');
        nextCard.style.zIndex = String(cards.length + 3);
      });

      window.setTimeout(function () {
        activeIndex = nextIndex;
        applyStack(activeIndex);
        // On évite de re-déclencher le swap + l'animation des bullets :
        // elles ont déjà été synchronisées juste avant le mouvement de stack.
        syncState(activeIndex);
        isAnimating = false;
      }, 760);
    }

    function goTo(nextIndex) {
      if (isAnimating || nextIndex === activeIndex || nextIndex < 0 || nextIndex >= cards.length) return;

      var activeCard = cards[activeIndex];
      var nextCard = cards[nextIndex];
      if (!activeCard || !nextCard) return;
      var previousIndex = activeIndex;
      var isNextCard = nextIndex === (activeIndex + 1) % cards.length;
      isAnimating = true;

      if (!isNextCard) {
        playCardSwap(previousIndex, nextIndex, activeCard, nextCard, false);
        return;
      }

      activeCard.classList.add('is-shrinking');
      window.setTimeout(function () {
        playCardSwap(previousIndex, nextIndex, activeCard, nextCard, true);
      }, 100);
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        goTo(i);
      });
    });

    bullets.forEach(function (bullet) {
      bullet.addEventListener('click', function () {
        var nextIndex = Number(bullet.getAttribute('data-bullet-index'));
        goTo(nextIndex);
      });
    });

    applyStack(activeIndex);
    syncState(activeIndex);

    window.addEventListener(
      'resize',
      function () {
        applyStack(activeIndex);
        syncState(activeIndex);
      },
      { passive: true }
    );
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-card-slider]').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
